//VacationTransService

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLsConfig } from '../URLsConfig';
import { VacBalanceModel, VacationTransModel,VacationDetModel} from '../models/VacationTransModel';
@Injectable({
  providedIn: 'root'
})
export class VacationTransService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
  }


  public GetVacationTrans(vacnumber:number ,vackind :string, comcode: string) {
    let params = new HttpParams();


    params = params.append("vacnumber", vacnumber);
    params = params.append("vackind", vackind);
    params = params.append("CompCode", comcode);

    const options = {
        params: params
    };
    return this.http.get<VacationTransModel>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/GetVacationTrans', options);
  }
  public GetVacationTransCheck(vacempcode :string, resdate: string) {
    let params = new HttpParams();


    params = params.append("VacEmpCode", vacempcode);
    params = params.append("ResDate", resdate);


    const options = {
        params: params
    };
    return this.http.get<VacationTransModel>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/GetVacationTransCheck', options);
  }
  public GetVacationBalance(vacempcode :string ,vackind :string,vactype :string,vacperiod:string, comcode: string) {
    let params = new HttpParams();


    params = params.append("vacempcode", vacempcode);
    params = params.append("vackind", vackind);
    params = params.append("vactype", vactype);
    params = params.append("vacperiod", vacperiod);
    params = params.append("CompCode", comcode);

    const options = {
        params: params
    };
    return this.http.get<VacBalanceModel>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/GetVacationTBalance', options);
  }

  public AddVacationTrans(user: VacationTransModel) {
    return this.http.post<VacationTransModel>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/AddVacationTrans', user);
  }
  public DelVacationTrans(vacnumber : number,vackind :string, comcode: string) {
    let params = new HttpParams();
    params = params.append("vacnumber", vacnumber);
    params = params.append("vackind", vackind);
    params = params.append("CompCode", comcode);
    const options = {
      params: params
    };
    return this.http.get<VacationTransModel>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/DeleteVacationTrans', options);
  }

  public GetVacationTransSerial(vackind :string, comcode: string) {
    let params = new HttpParams();

    params = params.append("vackind", vackind);
    params = params.append("CompCode", comcode);

    const options = {
        params: params
    };
    return this.http.get<VacationTransModel>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/GetVacationTransSerial', options);
  }

  public GetVacationTransTop(vackind :string, comcode: string) {
    let params = new HttpParams();
    params = params.append("vackind", vackind);
    params = params.append("CompCode", comcode);

    const options = {
        params: params
    };
    return this.http.get<VacationTransModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/VacationTransToopLookup', options);
  }

  public DelVacationDet(DetEmpCode : string, DetFromDate : string, DetToDate: string, comcode: string) {
    let params = new HttpParams();
    params = params.append("DetEmpCode", DetEmpCode);
    params = params.append("DetFromDate", DetFromDate);
    params = params.append("DetToDate", DetToDate);

    params = params.append("CompCode", comcode);
    const options = {
      params: params
    };
    return this.http.get<VacationDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/DeleteVacationDet', options);
  }
  public AddVacationDet(DetEmpCode : string,DetEmpDate :string,todate:string, vactype:string,TType :string,compcode: string) {
   console.log("Dates :",DetEmpCode,DetEmpDate,todate)
    let params = new HttpParams();
    params = params.append("DetEmpCode", DetEmpCode);
    params = params.append("DetFromDate", DetEmpDate);
    params = params.append("todate", todate);
    params = params.append("TType", TType);
    params = params.append("EmpVacType", vactype);
    params = params.append("CompCode", compcode);
    const options = {
      params: params
    };
    return this.http.get<VacationDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/VacationTrans/AddVacationDet', options);
  }



}

